import Box from '@mui/material/Box';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { t } from 'i18next';
import { ReactNode, useEffect, useState } from 'react';

import TreadLiveMapV2 from '~components/Maps/v2/TreadLiveMapV2';
import { Job } from '~hooks/useJob/models';
import { useJob } from '~hooks/useJob/useJob';
import { Load } from '~hooks/useLoad/models';

export const ROUTE_MAP_HEIGHT_IN_PX = 400;

interface Props {
  job: Job;
  defaultTimelineVisible?: boolean;
  extraActions?: ReactNode;
  hideRouteHistoryAction?: boolean;
  sx?: SxProps<Theme>;
}

const RouteMap = ({
  job,
  defaultTimelineVisible = false,
  extraActions,
  hideRouteHistoryAction,
  sx = {},
}: Props) => {
  const [isTimelineVisible, setIsTimelineVisible] =
    useState<boolean>(defaultTimelineVisible);
  const [loads, setLoads] = useState<Load[]>([]);
  const { isLoading: isLoadingJobLoads, getJobLoads } = useJob();

  useEffect(() => {
    if (job?.id) {
      getJobLoads(job.id).then(setLoads);
    } else {
      setLoads([]);
    }
  }, [job?.id]);

  return (
    <Box sx={{ width: '100%', height: ROUTE_MAP_HEIGHT_IN_PX, ...sx }}>
      {job && !isLoadingJobLoads ? (
        <TreadLiveMapV2
          // When the timeline is shown by default (e.g. Route History), eagerly load
          // the route pings so the scrubber has data on mount instead of waiting for
          // the (now-hidden) "View Route History" button.
          extraActions={extraActions}
          hideRouteHistoryAction={hideRouteHistoryAction}
          lazyLoadJobPings={!defaultTimelineVisible}
          job={job}
          isTimelineVisible={isTimelineVisible}
          onTimelineVisibilityChange={setIsTimelineVisible}
          loads={loads}
        />
      ) : (
        <>{t('actions.loading')}</>
      )}
    </Box>
  );
};

export { RouteMap };
